<template>
  <div class="contact">

    <div class="banner">
      <img src="../../assets/img/contact/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("contact.banner.bannerTitle")}}</h1>
          <p>{{$t("contact.banner.bannerP")}}</p>
        </div>
      </div>
    </div>

    <div class="container main">
      <el-row :gutter="40">
        <el-col :span="12" :xs="24">
          <ul class="desc-lists">
            <li v-for="(item,index) in $t('contact.descLists')" :key="index">
              <div class="box">
                <img :src="item.url" alt="">
                <h3 >{{item.title}}</h3>
                <div v-html='item.desc'></div>
              </div>
            </li>
          </ul>
          <el-row :gutter="30" class="icon-row">
            <el-col :span="8">
              <img src="../../assets/img/contact/gzh.png" alt="">
              <div>{{$t('contact.wxName')}}</div>
            </el-col>
            <el-col :span="8">
              <img src="../../assets/img/contact/douying.png" alt="">
              <div>{{$t('contact.dyName')}}</div>
            </el-col>
            <!-- <el-col :span="8">
              <img src="../../assets/img/contact/weidian.png" alt="">
              <div>{{$t('contact.wdName')}}</div>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="12" :xs="24"> 
          <img src="../../assets/img/contact/wukuang.png" alt="" class="map">
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import AMap from "AMap";
export default {
  name: "contact",
  data() {
    return {};
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    // this.init();
  },
  methods: {
    // init() {
    //   let map = new AMap.Map("map-container", {
    //     center: [116.412936, 39.98929],
    //     resizeEnable: true,
    //     zoom: 15
    //   });

    //   // 创建一个 Marker 实例：
    //   var marker = new AMap.Marker({
    //     position: new AMap.LngLat(116.412936, 39.98929), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
    //     offset: new AMap.Pixel(-10, -10),
    //     title: "中国五矿大厦"
    //   });

    //   // 将创建的点标记添加到已有的地图实例：
    //   map.add(marker);
    // }
  }
};
</script>

<style scoped lang="scss">
.contact{
  .main{
    margin-top:-30%;
    background:#fff;
    border-radius: 16px; 
    padding:50px;
    box-shadow: 0 0 4px rgba(0,0,0,0.5);
    .desc-lists{
      li{
        padding-bottom:20px;
        .box{
          position: relative;
          padding-left: 60px;
          img{
            position: absolute;
            left:0;
            top:5px;
            width:38px;
          }
          h3{
            font-weight: bold;
          }
        }
      }
    }
    .icon-row{
      text-align: center;
    }
    #map-container {
      width: 100%;
      height: 400px;
    }
  }
    @media screen and (max-width:768px){
      .main{
        margin-top:0;
      }
      .map {
        margin-top:30px;
      }
    }
}
</style>
